<template>
  <div>
    <b-img
      class="img-cover-card"
      :src="campaign.cover"
      alt="Cover Image"
    ></b-img>

    <div class="container-margin-negative">
      <div class="d-flex mb-2 container-avatar-title-header">
        <b-avatar
          class="avatar-header-custom-link-invitation p-05"
          size="120"
          variant="light"
          :src="campaign.logo"
          badge
          :badge-variant="getVariant()"
          badge-offset="0.5em"
        >
        </b-avatar>
        <h1 class="align-self-end ml-lg-1">
          {{campaign.name}}
        </h1>
      </div>
      <b-alert class="bg-alert-success w-100 mb-2" show>
        <p class="p-1 jumbo-text">
          {{$t('invitation.invitationCampaign')}}
        </p>
      </b-alert>
    </div>

  </div>
</template>

<script>
import { 
  BAvatar, 
  BImg,
  BAlert,
} from "bootstrap-vue";
import utils from "@/libs/utils"

export default {
  name: 'HeaderInvitation',
  components: {
    BAvatar,
    BImg,
    BAlert,
  },
  props: {
    campaign: {
      required: true,
      type: Object,
    }
  },
  data() {
    return {
      utils
    }
  },
  mounted() {
    const img_card = document.querySelector('.img-cover-card')
    img_card.style.setProperty('background-image',  `linear-gradient(0deg, rgba(90,90,90,1) 20%, rgba(0,0,0,0) 89%), url(${this.campaign.cover})`)
  },
  methods: {
    getVariant() {
      return this.campaign.is_archived ? 'warning' : 'success';
    },
  }
};
</script>

<style lang="scss" scoped>
  .img-cover-card {
    color: white;
    // width: 100%;
    width: 100%;
    height: 200px;
    object-fit: cover;
    
  }
  .container-margin-negative {
    color: #FFF;
    display: flex;
    flex-wrap: wrap;
    margin-top: -4.5rem;
    padding: 0 1.5em;
    h1 { 
      text-shadow: 1px 1px 2px #ffffffe7;
      margin-top: 2.5em;
    }
  }
  .bg-alert-success {
    background-image: linear-gradient(to left,#237ca4,#57daac) !important;
    color: #FFF !important;
  }
  .jumbo-text {
    font-size: 20px;
    text-align: left;
    line-height: 1.2;
  }
  @media(max-width: 992px) {
    .container-avatar-title-header {
      flex-wrap: wrap;
      justify-content: center;
    }
    h1 {
      margin-top: 1em !important;
      text-align: center;
    }
  }
</style>
<style lang="scss">
.avatar-header-custom-link-invitation .b-avatar-badge {
  font-size: 15px !important;
}
</style>